export const BREAKPOINTS = {
  S: 480,
  M: 720,
  L: 1024,
};
